import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps, ElementType } from 'react';
import { cn } from '@savvy-kit/lib/utils';
import { cva } from 'class-variance-authority';
import { AlertCircle, AlertTriangle, ArrowDownRight, ArrowUpRight, CheckCircle, Info } from 'lucide-react';

const feedbackVariants = cva('inline-flex items-center gap-1 text-xs', {
  variants: {
    variant: {
      info: 'text-info',
      success: 'text-success',
      critical: 'text-destructive',
      warning: 'text-warning-foreground-dark',
      positive: 'text-success',
      negative: 'text-destructive',
    },
  },
  defaultVariants: {
    variant: 'info',
  },
});

const variantIcons: Record<NonNullable<VariantProps<typeof feedbackVariants>['variant']>, ElementType> = {
  info: Info,
  success: CheckCircle,
  critical: AlertTriangle,
  warning: AlertCircle,
  positive: ArrowUpRight,
  negative: ArrowDownRight,
};

type FeedbackProps = ComponentProps<'span'> &
  VariantProps<typeof feedbackVariants> & {
    icon?: ElementType;
  };

function Feedback({ className, variant = 'info', icon, children, ...props }: FeedbackProps) {
  const Icon = icon ?? variantIcons[variant ?? 'info'];

  return (
    <span data-slot="feedback" className={cn(feedbackVariants({ variant }), className)} {...props}>
      <Icon className="size-4 shrink-0" />
      {children}
    </span>
  );
}

export { Feedback, feedbackVariants };
export type { FeedbackProps };
